import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import ENV from '../../env'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    doyangSurrogations: [],
    doyangSurrogation: {}
  },
  mutations: {
    index(state, payload) {
      state.doyangSurrogations = payload
    },
    show(state, payload) {
      state.doyangSurrogation = payload
    },
    delete(state,payload) {
      state.doyangSurrogation = state.doyangSurrogation.filter((size) => size.id != payload.id)
    }
  },
  actions: {
    index({ commit }, payload) {
      return axios.get(`${ENV.API_URL}/api/doyang_surrogations${payload || ''}`).then((res) => {
        commit('index', res.data)
        return res.data
      })
    },
    show({ commit }, payload) {
      return axios.get(`${ENV.API_URL}/api/doyang_surrogations/${payload}`).then((res) => {
        commit('show', res.data)
        return res.data
      })
    },
    create({ commit }, payload) {
      return axios.post(`${ENV.API_URL}/api/doyang_surrogations`, payload).then((res) => {
        commit('show', res.data)
        return res.data
      })
    },
    update({ commit }, payload) {
      return axios.put(`${ENV.API_URL}/api/doyang_surrogations/${payload.id}`, payload).then((res) => {
        commit('show', res.data)
        return res.data
      })
    },
    delete({commit}, payload) {
      return axios.delete(`${ENV.API_URL}/api/doyang_surrogations/${payload}`).then((res) => {
        commit('delete', res.data)
        return res.data
      })
    }
  },
  getters: {
    doyangSurrogation: state => {
      return state.doyangSurrogation
    },
    doyangSurrogations: state => {
      return state.doyangSurrogations
    }
  },
  modules: {
  }
}
